import React, { useState, useEffect } from 'react';
import { Clock, TrendingUp } from 'lucide-react';
import AdDisplay from "./AdDisplay";
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const WebSidebar = ({ onVideoClick }) => {
  const [latest, setLatest] = useState([]);
  const [trending, setTrending] = useState([]);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/videos?limit=10&sort=newest`).then(r => setLatest(r.data.videos || [])).catch(() => {});
    axios.get(`${BACKEND_URL}/api/videos?limit=10&sort=popular`).then(r => setTrending(r.data.videos || [])).catch(() => {});
  }, []);

  const SideList = ({ title, icon, videos, color }) => (
    <div className="web-sidebar-section">
      <h3 className="web-sidebar-title" style={{ borderLeftColor: color }}>
        {icon} {title}
      </h3>
      <ul className="web-sidebar-list">
        {videos.length === 0 ? (
          <li className="web-sidebar-empty">No videos yet</li>
        ) : videos.map(v => (
          <li key={v.id} className="web-sidebar-item" onClick={() => onVideoClick && onVideoClick(v)}>
            <span className="web-sidebar-link">{v.title}</span>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <aside className="web-sidebar">
      <SideList title="Bokep Terbaru" icon={<Clock size={14} />} videos={latest} color="#f59e0b" />
      <SideList title="Trending" icon={<TrendingUp size={14} />} videos={trending} color="#ef4444" />
      <AdDisplay position="sidebar" style={{ width: "100%", height: 250 }} />
    </aside>
  );
};

export default WebSidebar;
